import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import { parseBooleanValue, parseCsvCalendarDate } from '~/prix/utils/bulk/csvValueParsers'
import clearString from '~/prix/utils/bulk/clearString'

const medicalProcedureRequested: Dataset = {
  schema: 'public_health',
  table: 'medical_procedure_requested',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    attendance_original_id: original => original,
    name: original => clearString(original as string),
    is_evaluated: original => parseBooleanValue(original as string),
    sigtap_code: original => original,
    exam_result: original => clearString(original as string),
    exam_result_date: original => parseCsvCalendarDate(original as string),
    exam_performed_date: original => parseCsvCalendarDate(original as string),
    exam_request_date: original => parseCsvCalendarDate(original as string),
    observation: original => clearString(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default medicalProcedureRequested
